export const MAX_COMMENT_FILE_SIZE_MB = 15;
export const MAX_COMMENT_FILE_SIZE_BYTES = MAX_COMMENT_FILE_SIZE_MB * 1024 * 1024;

export const FILE_SIZE_HINT = `${MAX_COMMENT_FILE_SIZE_MB} MB max per file`;
